export default "__VITE_ASSET__bTR3EGU6__"